import { render, staticRenderFns } from "./AboutCardsMob.vue?vue&type=template&id=f1d4ae1a&scoped=true"
import script from "./AboutCardsMob.vue?vue&type=script&lang=js"
export * from "./AboutCardsMob.vue?vue&type=script&lang=js"
import style0 from "./AboutCardsMob.vue?vue&type=style&index=0&id=f1d4ae1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d4ae1a",
  null
  
)

export default component.exports